// import { faTemperatureHigh } from '@fortawesome/free-solid-svg-icons'
import { clearExceptIsRead } from '@/components/Header/Notice.js';
import * as Sentry from '@sentry/vue';
import { authApi } from '@/utils/api';

const admin = {
  namespaced: true,
  state: {
    report_code: '',
    report_list: [],
    is_report_list_loaded: false
  },
  mutations: {
    update_report_list(state, report_list) {
      const temp_list = report_list;
      state.report_list = temp_list;
    },
    update_report_code(state, new_code) {
      state.report_code = new_code;
    },
    update_report_list_loaded(state, flag) {
      state.is_report_list_loaded = flag;
    }
  },
  getters: {
    selected_report(state) {
      const idx = state.report_list.findIndex(item => item.report_code == state.report_code);
      if (idx > -1) {
        return state.report_list[idx];
      }
    },
    hashed_report_list(state) {
      const temp_list = [...state.report_list];
      const temp_obj = {};
      for (let i = 0; i < temp_list.length; i++) {
        temp_obj[temp_list[i].report_code] = temp_list[i];
      }
      return temp_obj;
    }
  },
  actions: {
    // 모든 리스트를 불러오기 => report_list.js와 읽어오는 데이터 다르므로 주의해야 합니다
    readAllReportListForAdmin({ commit, rootState }) {
      return authApi.get('/read_report_list_for_admin').then(response => {
        console.log(response);
        const report_list = response.data;

        commit('update_report_list', report_list);
        commit('update_report_list_loaded', true);
      });
    },
    async check_valid_admin_right({ rootState }) {
      try {
        const response = await authApi.get('/check_admin');

        if (!response.data.code) {
          clearExceptIsRead();
          window.alert('관리자 세션이 만료되었습니다. 다시 로그인해 주시기 바랍니다.');
          location.href = '/';
        }
      } catch (error) {
        window.alert(error);
        clearExceptIsRead();
        location.href = '/';
        error.message = '[관리자 로그인]' + error.message;
        Sentry.captureException(error);
      }
    },
    async check_valid_login_right({ rootState }) {
      try {
        // access_token이 없으면 세션 만료 처리
        if (!rootState?.access_token) {
          clearExceptIsRead();
          window.alert('세션이 만료되었습니다. 다시 로그인해 주시기 바랍니다.');
          location.href = '/';
          return;
        }

        const response = await axios.get(
          rootState.backend_host +
            '/confirm_login_status?access_token=' +
            rootState.access_token.replaceAll('+', '%2B')
        );
        if (!response.data.code) {
          clearExceptIsRead();
          window.alert('세션이 만료되었습니다. 다시 로그인해 주시기 바랍니다.');
          location.href = '/';
        }
      } catch (error) {
        window.alert(error);
        clearExceptIsRead();
        location.href = '/';
        error.message = '[로그인 이슈]' + error.message;
        Sentry.captureException(error);
      }
    }
  }
};
export default admin;
